import { Avatar, Box, Grid, Radio, Typography } from "@mui/material";
import { styled } from "@mui/system";
import PForPeep from "assets/icons/PForPeep";
import UnselectedStaff from "assets/icons/UnselectedStaff";
import { useTranslation } from "react-i18next";

type BookingEmployeeRadioProps = {
  name: Nullable<string>;
  checked: boolean;
  available: boolean;
  onClick: () => void;
  avatarSrc: string;
};

export default function BookingEmployeeRadio(props: BookingEmployeeRadioProps) {
  const { t } = useTranslation("bookingPage");

  const { name, checked, available, onClick, avatarSrc } = props;

  return (
    <EmployeeRadioWrapper disabled={!available} onClick={available ? onClick : () => {}}>
      <Grid container>
        <Grid item xs={8} display="flex" alignItems="center">
          <StaffAvatarWrapper>
            {name ? (
              <Avatar alt={name} src={avatarSrc} sx={{ width: 40, height: 40 }}>
                <PForPeep fontSize="large" />
              </Avatar>
            ) : (
              <Avatar alt="unselected staff" src={avatarSrc} sx={{ width: 40, height: 40 }}>
                <UnselectedStaff />
              </Avatar>
            )}
          </StaffAvatarWrapper>
          <Box>
            <Typography variant="primary" fontWeight="700" color="text.label" component="h4">
              {name || t("anyStaff")}
            </Typography>

            <Typography variant="secondary" fontWeight="500" color="text.primary" component="p">
              {available ? t("available") : t("busyDuringSlot")}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Radio checked={checked} disabled={!available} />
        </Grid>
      </Grid>
    </EmployeeRadioWrapper>
  );
}

type EmployeeRadioWrapperProps = {
  disabled: boolean;
};

const EmployeeRadioWrapper = styled(Box)<EmployeeRadioWrapperProps>(({ theme, disabled }) => ({
  background: disabled ? theme.palette.bg.disabled : null,
  border: `1px solid ${theme.palette.common.gray}24`,
  borderRadius: 4,
  minHeight: "64px",
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  cursor: "pointer",
}));

const StaffAvatarWrapper = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(1.5),
  ".MuiSvgIcon-root": {
    width: 31,
    height: 31,
  },
}));
